/* Parwin per-variant gallery: swaps a full image set when the variant changes.
   Listens to the theme's native 'variant:update' event (e.detail.resource.id).
   No external libraries. */
(function () {
  function initRoot(root) {
    if (root.__pvgInit) return;
    root.__pvgInit = true;
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('.pvg__thumb');
      if (!btn || !root.contains(btn)) return;
      var panel = btn.closest('.pvg__panel');
      if (!panel) return;
      var main = panel.querySelector('.pvg__main-img');
      var full = btn.getAttribute('data-full');
      if (main && full) { main.src = full; }
      panel.querySelectorAll('.pvg__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      btn.classList.add('is-active');
    });
  }

  function showVariant(root, id) {
    var panels = root.querySelectorAll('.pvg__panel[data-variant-id]');
    panels.forEach(function (p) {
      var match = p.getAttribute('data-variant-id') === String(id);
      p.hidden = !match;
      p.classList.toggle('is-active', match);
    });
  }

  function ready() {
    document.querySelectorAll('variant-gallery.pvg').forEach(initRoot);
  }
  if (document.readyState !== 'loading') ready();
  else document.addEventListener('DOMContentLoaded', ready);

  document.addEventListener('variant:update', function (e) {
    var id = e.detail && e.detail.resource && e.detail.resource.id;
    if (!id) return;
    document.querySelectorAll('variant-gallery.pvg').forEach(function (root) {
      initRoot(root);
      showVariant(root, id);
    });
  });
})();
